class CookieTrigger extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)
    this.listeners.add(this, 'click', this.handleTrigger)
  }

  handleTrigger (event) {
    window.Pandectes.fn.showBanner()
  }
}

if (!customElements.get('cookie-trigger')) {
  customElements.define('cookie-trigger', CookieTrigger)
}
